import { render, staticRenderFns } from "./RawData.vue?vue&type=template&id=1a952614&scoped=true&"
import script from "./RawData.vue?vue&type=script&lang=ts&"
export * from "./RawData.vue?vue&type=script&lang=ts&"
import style0 from "./RawData.vue?vue&type=style&index=0&id=1a952614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a952614",
  null
  
)

export default component.exports